module.exports = __webpack_public_path__ + "static/bee-qauntum-9ff69fdd3af8a646c93c8157b0ed0c97.jpg";